import React from 'react';
import {UsePermissions} from "../../hooks/usePermissions";
import {Navigate} from "react-router";
import {PayTable} from "./components/PayTable";

export const PagoFondosPage = () => {
    const [permisos] = UsePermissions();
    return (
        <div className="container-relative">
            {permisos.consultar ? <PayTable  />: <Navigate to="/home"/> }
        </div>
    );
};
